import mixins from 'vue-typed-mixins';
import { AxiosResponse } from 'axios';

import { GoogleLoginRequest, LoginRequest } from '@/openapi/user';
import { HttpStatusCode } from '@/openapi/enum';
import { ErrorResponse } from '@/openapi/common';

import AlertDialog from '@/user/components/dialog/alert/AlertDialog.vue';
import GoogleSignin from '@/components/googleSignin/GoogleSignin.vue';

import RoomMixin from '@/user/mixins/RoomMixin';
import RoutesMixin from '@/user/mixins/RoutesMixin';
import UserMixin from '@/user/mixins/UserMixin';
import WindowAdjustMixin from '@/user/mixins/WindowAdjustMixin';

import UserApiUtility from '@/classes/common/UserApiUtility';
import { PUBLIC_PATH } from '@/classes/common/Constants';




export default mixins(RoomMixin, RoutesMixin, UserMixin, WindowAdjustMixin).extend({

  name: 'Login',

  components: {
    AlertDialog,
    GoogleSignin,
  },

  data(): {
    readonly publicPath: string;
    password: string;
    visibleLoginErrorDialog: boolean;
    errorResponse: ErrorResponse | null;
  } {
    return {
      publicPath: PUBLIC_PATH,
      password: '',
      visibleLoginErrorDialog: false,
      errorResponse: null,
    };
  },

  computed: {
    errorMessage(): string {
      return this.errorResponse?.message ?? '';
    },
  },

  async created(): Promise<void> {
    await this.setRoomState(this.$route.params.roomId);
    // デモ教室の場合、体験ユーザーとして処理
    if (this.isDemo) {
      this.guestLogin();
      return;
    }

    // tokenが存在する場合（ログアウトしていない場合）、科目選択画面に遷移
    if (UserApiUtility.hasToken()) this.$router.push(this.routes.CourseSelect);
  },

  methods: {
    async login(): Promise<void> {
      this.errorResponse = null;

      const params = {
        roomId: this.roomId,
        loginKey: this.password
      } as LoginRequest;

      const response: AxiosResponse<void | ErrorResponse> = await UserApiUtility.getLoginApi().login(params);
      if (response.status === HttpStatusCode.unauthorized) {
        this.errorResponse = response.data as ErrorResponse;
        this.visibleLoginErrorDialog = true;
        return;
      }

      this.$router.push(this.routes.CourseSelect);
    },
    guestLogin(): void {
      this.setGuestUserState();
      this.$router.push(this.routes.CourseSelect);
    },
    inputPassword(num: number): void {
      if (20 < this.password.length + 1) return;
      this.password += num;
    },
    slicePasswordTail(): void {
      if (this.password.length === 0) return;
      this.password = this.password.slice(0, -1);
    },
    async onGoogleAuthorised(googleUser: any): Promise<void> {
      const params: GoogleLoginRequest = {
        roomId: this.roomId,
        credential: googleUser.credential
      };

      const response: AxiosResponse<void | ErrorResponse> = await UserApiUtility.getLoginApi().googleLogin(params);
      if (response.status === HttpStatusCode.unauthorized) {
        this.errorResponse = { message: '認証に失敗しました。' } as ErrorResponse;
        this.visibleLoginErrorDialog = true;
        return;
      }

      this.$router.push(this.routes.CourseSelect);
    },
  },



});
